import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import DropDownMenu from '../../DropDownMenu.jsx';

const messages = defineMessages({
    title: {
        id: 'timetable.matches_filter_menu.title',
        defaultMessage: 'Показать'
    },
    no_filter: {
        id: 'timetable.matches_filter_menu.no_filter',
        defaultMessage: 'Все события'
    },
    one_hour: {
        id: 'timetable.matches_filter_menu.one_hour',
        defaultMessage: 'Ближайщий час'
    },
    two_hours: {
        id: 'timetable.matches_filter_menu.two_hours',
        defaultMessage: 'Ближайщие 2 часа'
    },
    four_hours: {
        id: 'timetable.matches_filter_menu.four_hours',
        defaultMessage: 'Ближайщие 4 часа'
    },
    six_hours: {
        id: 'timetable.matches_filter_menu.six_hours',
        defaultMessage: 'Ближайщие 6 часов'
    },
    twelve_hours: {
        id: 'timetable.matches_filter_menu.twelve_hours',
        defaultMessage: 'Ближайщие 12 часов'
    },
    one_day: {
        id: 'timetable.matches_filter_menu.one_day',
        defaultMessage: 'Ближайщий день'
    },
    two_days: {
        id: 'timetable.matches_filter_menu.two_days',
        defaultMessage: 'Ближайщие 2 дня'
    }
});

function _localizedLink(message, onClick, isActive = false) {
    const linkClass = isActive ? 'dropdown--menu__link active' : 'dropdown--menu__link';

    return (
        <FormattedMessage {...message}>
            {(localizedMessage) =>
                <a href="#" className={linkClass} onClick={onClick}>{localizedMessage}</a>}
        </FormattedMessage>
    );
}

export default class FilterMatchesMenu extends React.Component {
    static propTypes = {
        onFilterClick: React.PropTypes.func.isRequired,
        onClosing: React.PropTypes.func.isRequired,
        activeElement: React.PropTypes.any
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {onFilterClick, activeElement} = this.props;

        const cssClass = 'dropdown--menu__schedule';

        const curryFilter = (filter) => () => onFilterClick(filter);

        const elements = [
            {content: _localizedLink(messages.no_filter, curryFilter(null), (activeElement === null))},
            {content: _localizedLink(messages.one_hour, curryFilter(1), (activeElement === 1))},
            {content: _localizedLink(messages.two_hours, curryFilter(2), (activeElement === 2))},
            {content: _localizedLink(messages.four_hours, curryFilter(4), (activeElement === 4))},
            {content: _localizedLink(messages.six_hours, curryFilter(6), (activeElement === 6))},
            {content: _localizedLink(messages.twelve_hours, curryFilter(12), (activeElement === 12))},
            {content: _localizedLink(messages.one_day, curryFilter(24), (activeElement === 24))},
            {content: _localizedLink(messages.two_days, curryFilter(48), (activeElement === 48))}
        ];

        const title = (<FormattedMessage {...messages.title}/>);

        return (
            <DropDownMenu cssClass={cssClass}
                          title={title}
                          elements={elements}
                          onClosing={this.props.onClosing}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/Timetable/components/FilterMatchesMenu.jsx